import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import React, { useState, useEffect, Fragment, useRef } from 'react';
// import multicolor from '../../images/multicolor-hline.jpg';
// import Navbar from '../Navbar';
import Footer from './Footer';
import moment from 'moment/moment';
// import gmapicon from '../../images/gmap-icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { resetData, setActiveTab, setAllSessions, setAllSpeakers, setAllSponsers, setAllVenues, setSearch, setSelectedCategory, setSelectedDelegate, setSelectedLanguage, setSelectedSpeaker, setSelectedVenue } from '../../redux/reducers/sessionReducers';
import { CalendarDays, ChevronLeft, ChevronRight, Search, User } from 'lucide-react';
import { Link } from 'react-router-dom';
// import { Checkbox } from '@nextui-org/react';
// import SessionShareModal from '../SessionShareModal';
import { userStore } from '../../store/userStore';
import MainHeader from './MainHeader';
import Loader from './Loader';
import BannerBg from '../../images/cover/inner-banner-bg.jpg';
import { useScrollToTop } from '../../hooks/ScrollTop';
import { BASE_URL } from '../../apis/api';
import SessionBrousher from './SessionBrousher';

const SessionList = () => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);

    // Redux selectors
    const allSessions = useSelector((state) => state.sessions.allSessions);
    const allSpeakers = useSelector((state) => state.sessions.allSpeakers);
    const allSponsers = useSelector((state) => state.sessions.allSponsers);
    const allVenues = useSelector((state) => state.sessions.allVenues);
    const selectedSpeaker = useSelector((state) => state.sessions.selectedSpeaker);
    const selectedVenue = useSelector((state) => state.sessions.selectedVenue);
    const activeTab = useSelector((state) => state.sessions.activeTab);
    const search = useSelector((state) => state.sessions.search);
    const selectedCategory = useSelector((state) => state.sessions.selectedCategory);
    const selectedLanguage = useSelector((state) => state.sessions.selectedLanguage);
    const selectedDelegate = useSelector((state) => state.sessions.selectedDelegate);
    const accessToken = userStore.getState().user.token;

    const [sessions, setSessions] = useState([]);
    const [sort, setSort] = useState('asc');
    const [isLoading, setIsLoading] = useState(true);
    const [speakerFilter, setSpeakerFilter] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const boxRefs = useRef({});
    const [maxContentHeight, setMaxContentHeight] = useState(0);

    const handleOpen = () => setIsOpen(true);
    const swiperRef = useRef(null);

    const getSessionData = async () => {
        dispatch(resetData())
        try {
            // const response = await fetch("https://ilfk-api.keralasahityaakademi.org/session/table-list", {
            const response = await fetch(`${BASE_URL}/session/table-list`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            }); const result = await response.json();
            const text = result?.data;

            // const response = await fetch("https://cf-cdn.keralaliteraturefestival.com/sessions.json");
            // if (response) {
            //   console.log(response);
            // }
            // const text = await response.text();
            const data = text;
            dispatch(setAllSessions(data))
            const sortData = sortSessionData(data);
            let filteredData = sortData
            if (activeTab) {
                filteredData = filteredData?.filter((session) =>
                    moment(session?.date).format('MMM D') === activeTab
                )
            }
            setSessions(filteredData);
            setIsLoading(false);
        } catch (error) {
            console.log("Error fetching data:", error.message);
            setIsLoading(false);
        }
    };

    // const sortSessionData = (sessions) => {

    //     return [...sessions]?.sort((a, b) => {

    //         const dateA = a?.date?.split('T')[0];
    //         const dateB = b?.date?.split('T')[0];

    //         let dateComparison = new Date(dateA) - new Date(dateB);

    //         if (dateComparison === 0) {
    //             const timeA = convertTimeToMinutes(a?.time_from);
    //             const timeB = convertTimeToMinutes(b?.time_from);
    //             dateComparison = timeA - timeB;
    //         }

    //         return sort === 'desc' ? -dateComparison : dateComparison;

    //     });
    // };

    const sortSessionData = (sessions) => {
    if (!Array.isArray(sessions)) {
        console.error("Expected 'sessions' to be an array but got:", sessions);
        return [];
    }

    return [...sessions].sort((a, b) => {
        const dateA = a?.date?.split('T')[0];
        const dateB = b?.date?.split('T')[0];

        let dateComparison = new Date(dateA) - new Date(dateB);

        if (dateComparison === 0) {
        const timeA = convertTimeToMinutes(a?.time_from);
        const timeB = convertTimeToMinutes(b?.time_from);
        dateComparison = timeA - timeB;
        }

        return sort === 'desc' ? -dateComparison : dateComparison;
    });
    };

    const convertTimeToMinutes = (timeStr) => {
        const [hours, minutes, seconds] = timeStr.split(':')?.map(Number);
        return (hours * 60) + minutes;
    };

    const getSpeakerData = async () => {
        try {
            const response = await fetch(`${BASE_URL}/speakers/table-list`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            }); const result = await response.json();
            const text = await result?.data;
            // const response = await fetch("https://cf-cdn.keralaliteraturefestival.com/speakers.json");
            // const text = await response.text();
            // const data = JSON.parse(text);
            const data = text;
            dispatch(setAllSpeakers(data))
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getVenueData = async () => {
        try {
            const response = await fetch(`${BASE_URL}/venue/table-list`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            }); const result = await response.json();
            const text = await result?.data;
            // const response = await fetch("https://cf-cdn.keralaliteraturefestival.com/venue.json");
            // const text = await response.text();
            // const data = JSON.parse(text);
            const data = text;
            dispatch(setAllVenues(data))
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getSessionSponsers = async () => {
        try {
            const session_sponsors = await fetch(`${BASE_URL}/session/sponsor/table-list`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            }); const sessionSponsors = await session_sponsors.json();
            const sessionSponsorsText = await sessionSponsors?.data;
            const sponsors = await fetch(`${BASE_URL}/sponsor/table-list`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                }
            }); const sponsor = await sponsors.json();
            const sponsorsText = await sponsor?.data;
            // const session_sponsors = await fetch("https://cf-cdn.keralaliteraturefestival.com/session_sponsor.json");
            // const sponsors = await fetch("https://cf-cdn.keralaliteraturefestival.com/sponsor.json");
            // const sessionSponsorsText = await session_sponsors.text();
            // const sponsorsText = await sponsors.text();
            // const sessionSponsorsData = JSON.parse(sessionSponsorsText);
            // const spornsorsData = JSON.parse(sponsorsText);
            const sessionSponsorsData = sessionSponsorsText;
            const spornsorsData = sponsorsText;
            const sessionData = sessionSponsorsData?.map(sesspo => {
                const sessionSponsor = spornsorsData?.find(sponsor => sesspo?.sponsorId === sponsor?.id);
                return {
                    ...sesspo,
                    sponsors: sessionSponsor?.name || ''
                };
            })
            dispatch(setAllSponsers(sessionData))
            // dispatch(setActiveTab('Aug 17'))
              if (!allSessions || allSessions.length === 0) {
                      dispatch(setActiveTab('Aug 17'));
                    } else { 
                      const dates = allSessions.map(item => new Date(item.date)); 
                      const earliestDate = new Date(Math.min(...dates));
 
                      const formattedDate = earliestDate.toLocaleString('en-US', {
                        month: 'short',
                        day: 'numeric',
                      });

                      dispatch(setActiveTab(formattedDate));
                    }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        getSessionData();
        // dispatch(setActiveTab('Dec 12'))
    }, []);

    useEffect(() => {
        getSpeakerData();
        getVenueData()
        getSessionSponsers()
    }, []);


    const findUniqueDates = () => {
        const sessionDates = allSessions
            ?.filter(session => session.date !== null)
            ?.map(session => moment(session.date).format('YYYY-MM-DD'));
        const uniqueDates = sessionDates?.filter((date, index) => sessionDates.indexOf(date) === index);
        const sortedDates = uniqueDates?.sort((a, b) => new Date(a) - new Date(b));
        const formattedDates = sortedDates?.map(date => moment(date).format('MMM D'));
        return formattedDates
    };

    const uniqueDates = findUniqueDates();

    const findUniqueCategories = () => {
        const sessionCategories = allSessions
            ?.filter(session => session?.category !== null)?.map(session => session?.category);
        const uniqueCategories = sessionCategories?.filter((category, index) => sessionCategories?.findIndex(cat => cat?.id === category?.id) === index);
        return uniqueCategories;
    };

    const uniqueCategories = findUniqueCategories()

    const findUniqueVenue = () => {
        const ve = sessions?.filter(session => session?.venue?.id != null)?.map(session => session?.venue)
        const uniqueVenue = ve?.filter((venues, index) => ve?.findIndex(cat => cat?.id === venues?.id) === index);
        return uniqueVenue
    };

    const uniqueVenue = findUniqueVenue()

    const handleSpeakerSearch = (e) => {
        if (e.target.value) {
            setSpeakerFilter(e.target.value)
        } else {
            handleSpeakerFilter("")
        }
    };


    const handleSpeakerFilter = (id) => {
        console.log(id);

        dispatch(setSelectedSpeaker(id))
        const speaker = allSpeakers.find((speaker) => speaker.id === id);
        if (speaker) {
            setSpeakerFilter(speaker.heading);
        } else {
            setSpeakerFilter('');
        }
        setIsDropdownOpen(false);
    };

    const handleVenueFilter = (e) => {
        dispatch(setSelectedVenue(e.target.value))
        dispatch(setActiveTab(""))
    };

    const handleTabClick = (formattedDate) => {
        console.log(formattedDate)
        dispatch(setActiveTab(formattedDate))
    };

    const handleSearch = (e) => {
        dispatch(setSearch(e.target.value))
        dispatch(setActiveTab(""))
    };

    const handleCategory = (e) => {
        dispatch(setSelectedCategory(e.target.value))
        dispatch(setActiveTab(""))
    };

    const handleLanguage = (e) => {
        dispatch(setSelectedLanguage(e.target.value))
        dispatch(setActiveTab(""))
    };

    const handleDelegate = (e) => {
        if (e.target.checked) {
            dispatch(setSelectedDelegate("YES"))
            dispatch(setActiveTab(""))
        } else {
            dispatch(setSelectedDelegate(""))
        }
    };


    useEffect(() => {
        let filteredData = allSessions
        if (selectedSpeaker) {
            dispatch(setActiveTab(''))
            filteredData = filteredData?.filter((session) =>
                session?.session_speackers?.some((element) => element.speaker.id === selectedSpeaker) ||
                session?.session_moderators?.some((element) => element.speaker.id === selectedSpeaker) ||
                session?.speakers?.some((element) => element.id === selectedSpeaker)
            );
        }
        if (search) {
            dispatch(setActiveTab(''))
            filteredData = filteredData?.filter((session) =>
                session?.name?.toLowerCase().includes(search.toLowerCase())
            );
        }
        if (selectedVenue) {
            dispatch(setActiveTab(''))
            filteredData = filteredData?.filter((session) =>
                session?.venue?.id === Number(selectedVenue)
            );
        }
        if (selectedCategory) {
            dispatch(setActiveTab(''))
            filteredData = filteredData?.filter((session) =>
                session?.category?.id === Number(selectedCategory)
            )
        }
        if (selectedLanguage) {
            dispatch(setActiveTab(''))
            filteredData = filteredData?.filter((session) =>
                session?.language === selectedLanguage
            )
        }
        if (activeTab) {
            filteredData = filteredData?.filter((session) =>
                moment(session?.date).format('MMM D') === activeTab
            )
        }
        if (selectedDelegate) {
            dispatch(setActiveTab(''))
            filteredData = filteredData?.filter((session) =>
                session?.delegative_exclusive === selectedDelegate
            )
        }
        const sortData = sortSessionData(filteredData);
        setSessions(sortData)
    }, [selectedSpeaker, search, selectedVenue, activeTab, selectedCategory, selectedLanguage, selectedDelegate, sort]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdown')) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `
          #root, .App {
            height: 100%;
          }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    useEffect(() => {
        const calculateMaxContentHeight = () => {
            let maxHeight = 0;
            uniqueVenue?.forEach((venue, index) => {
                const venueSessions = sessions?.filter(item => item?.venue?.id === venue?.id);
                const boxRef = boxRefs.current[`venue-${index}`];
                if (boxRef) {
                    const totalContentHeight = venueSessions?.reduce((acc, session) => {
                        return acc + 200;
                    }, 0);
                    maxHeight = Math.max(maxHeight, totalContentHeight);
                }
            });
            setMaxContentHeight(maxHeight);
        };

        calculateMaxContentHeight();
        window.addEventListener('resize', calculateMaxContentHeight);
        return () => window.removeEventListener('resize', calculateMaxContentHeight);
    }, [uniqueVenue, sessions]);

    useEffect(() => {
        const handleScroll = (sourceId, scrollTop) => {
            Object.entries(boxRefs.current).forEach(([id, ref]) => {
                if (id !== sourceId && ref) {
                    ref.scrollTop = scrollTop;
                }
            });
        };

        Object.entries(boxRefs.current).forEach(([id, ref]) => {
            if (ref) {
                ref.onscroll = (e) => handleScroll(id, e.target.scrollTop);
            }
        });

        return () => {
            Object.values(boxRefs.current).forEach(ref => {
                if (ref) {
                    ref.onscroll = null;
                }
            });
        };
    }, [uniqueVenue]);

    const cardColors = ['yellow', 'blue', 'red', 'green'];

    const formatSessionDateTime = (session, index) => {
        if (!session.date || !session.time_from || !session.time_to) return null;

        const day = moment(session.date).format('MMM DD');
        const color = cardColors[index % cardColors.length];

        const timeFrom = moment(session.time_from, 'HH:mm:ss').format('h:mm A');
        const timeTo = moment(session.time_to, 'HH:mm:ss').format('h:mm A');
        return {
            day,
            color,
            timeRange: `${timeFrom}-${timeTo}`
        };
    };


    // if (isLoading) {
    //     return <div className="flex justify-center items-center h-screen">Loading sessions...</div>;
    // }
    useScrollToTop();
    return (

        <div className="min-h-screen bg-slate-50 from-gray-100 to-gray-200 videoContainer">
            <MainHeader />
            {isLoading ? (
                <Loader />
            ) : (
                // <Fragment>
                <>
                    {/* Banner Section */}
                    <div className="min-h-[190px] flex justify-center items-center text-bla py-4 relative overflow-hidden"
                        style={{
                            backgroundImage: `url(${BannerBg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <div className="relative z-5 text-center px-4">
                            <h1 className="text-4xl sm:text-2xl font-bold drop-shadow-md">
                                <span className="text-yellow-400 text-[36px]">Sessions</span>
                            </h1>
                            <p className="text-white text-[15px] sm:text-[18px] mt-2 font-semibold opacity-90">
                                Stay updated with the latest from International Literature Festival of Kerala 2025
                            </p>
                        </div>
                    </div>

                    {/* Date Tabs - Modern Design */}
                    <div className="bg-white sticky top-0 z-10 shadow-sm DateSection">
                        <div className="container mx-auto px-4 flex justify-center">
                            <div className="flex overflow-x-auto scrollbar-hide py-2 absolute -top-[49px]">

                                {uniqueDates?.map((formattedDate, index) => {
                                    return (
                                        <button
                                            key={formattedDate}
                                            onClick={() => handleTabClick(formattedDate)}
                                            className={`flex-shrink-0 w-[80px] h-[80px] rounded-[20px] mx-2 transition-all duration-200 flex flex-col items-center justify-start pt-2 ${activeTab === formattedDate
                                                ? 'text-white'
                                                : 'text-black'
                                                }`}
                                            style={{
                                                backgroundColor: activeTab === formattedDate ? '#e13231' : '#f9cd26',
                                            }}
                                        >
                                            {/* Top spiral lines */}
                                            <div className="absolute top-[2px] flex space-x-[2px] mb-1">
                                                {Array.from({ length: 7 })?.map((_, i) => (
                                                    <div key={i} className="w-[3px] h-[10px] bg-white rounded-sm"></div>
                                                ))}
                                            </div>

                                            {/* Month text */}
                                            <span className="text-xs font-semibold">
                                                {formattedDate.split(' ')[0]} {/* Aug */}
                                            </span>

                                            {/* Date number */}
                                            <span className="text-2xl font-bold mt-1">
                                                {formattedDate.split(' ')[1]} {/* 17 */}
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Filters Section - Card Design */}
                    <div className="bg-white FilterSection">
                        <div className="container mx-auto px-4 p-2">
                            <div className='bg-white'>
                                <div className="bg-white rounded-xl overflow-visible">
                                    <div className="p-2">
                                        <div className="flex items-center justify-between mb-4">
                                        <h3 className="text-lg font-semibold text-gray-800">Filter Sessions</h3>
                                        <SessionBrousher />
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 filter">
                                            {/* Venue Filter */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Venue</label>
                                                <div className="relative">
                                                    <select
                                                        className="bg-white rounded-none border-b border-[#00000069] pl-0 block w-full pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                        value={selectedVenue || ''}
                                                        onChange={handleVenueFilter}
                                                    >
                                                        <option value="">All Venues</option>
                                                        {allVenues?.map((venue) => (
                                                            <option key={venue.id} value={venue.id}>
                                                                {venue?.name} {venue?.number && `(${venue?.number})`}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Event Type Filter */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Event Type</label>
                                                <div className="relative">
                                                    <select
                                                        className="bg-white rounded-none border-b border-[#00000069] pl-0 block w-full pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                        value={selectedCategory || ''}
                                                        onChange={handleCategory}
                                                    >
                                                        <option value="">All Events</option>
                                                        {uniqueCategories?.map((category) => (
                                                            <option key={category.id} value={category.id}>
                                                                {category.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Language Filter */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Language</label>
                                                <div className="relative">
                                                    <select
                                                        className="bg-white rounded-none border-b border-[#00000069] pl-0 block w-full pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                        value={selectedLanguage || ''}
                                                        onChange={handleLanguage}
                                                    >
                                                        <option value="">All Languages</option>
                                                        {["Malayalam", "English"]?.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Delegate Filter */}
                                            <div className="flex items-end">
                                                <div className="flex items-center h-10">
                                                    <div className="flex items-center">
                                                        <input
                                                            id="delegate-filter"
                                                            type="checkbox"
                                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                                            checked={selectedDelegate === "YES"}
                                                            onChange={handleDelegate}
                                                        />
                                                        <label htmlFor="delegate-filter" className="ml-2 block text-sm text-gray-700">
                                                            Delegate only
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Speaker Filter */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                                                    Speakers
                                                </label>


                                                <div className="dropdown relative w-full">
                                                    {/* Lucide Search Icon */}
                                                    {/* <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" /> */}
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>

                                                    {/* Input Field */}
                                                    <input
                                                        type="text"
                                                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                        placeholder="Search speakers..."
                                                        value={speakerFilter}
                                                        onChange={handleSpeakerSearch}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setIsDropdownOpen(true);
                                                        }}
                                                    />

                                                    {/* Dropdown */}
                                                    {isDropdownOpen && (
                                                        <div
                                                            className="absolute w-full bg-white shadow-lg rounded-md mt-1 z-50"
                                                            style={{
                                                                maxHeight: '300px',
                                                                overflowY: 'auto',
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <button
                                                                type="button"
                                                                className={`w-full text-left px-4 py-2 text-sm hover:bg-blue-100 ${selectedSpeaker === '' ? 'bg-blue-100 font-medium' : ''
                                                                    }`}
                                                                onClick={() => {
                                                                    handleSpeakerFilter('');
                                                                    setIsDropdownOpen(false);
                                                                }}
                                                            >
                                                                All Speakers
                                                            </button>

                                                            {allSpeakers
                                                                ?.filter((speaker) =>
                                                                    speaker.heading.toLowerCase().includes(speakerFilter.toLowerCase())
                                                                )
                                                                ?.map((speaker) => (
                                                                    <button
                                                                        key={speaker.id}
                                                                        type="button"
                                                                        className={`w-full text-left px-4 py-2 text-sm hover:bg-blue-100 ${selectedSpeaker === speaker.heading ? 'bg-blue-100 font-medium' : ''
                                                                            }`}
                                                                        onClick={() => {
                                                                            handleSpeakerFilter(speaker.id);
                                                                            setIsDropdownOpen(false);
                                                                        }}
                                                                    >
                                                                        {speaker.heading}
                                                                    </button>
                                                                ))}

                                                            {allSpeakers?.filter((speaker) =>
                                                                speaker.heading.toLowerCase().includes(speakerFilter.toLowerCase())
                                                            ).length === 0 && (
                                                                    <div className="px-4 py-2 text-sm text-gray-400">No speakers found</div>
                                                                )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>


                                            {/* Search Filter */}
                                            <div>
                                                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Search</label>
                                                <div className="relative">
                                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                        placeholder="Search programme..."
                                                        value={search}
                                                        onChange={handleSearch}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Colorful Divider */}
                    {/* <div className="h-2 bg-gradient-to-r from-yellow-400 via-red-500 to-blue-500"></div> */}

                    {/* Sessions Swiper - Modern Card Design */}
                    <div className="bg-slate-100 py-2 SessionsContainer">
                        <div className="container mx-auto px-4">
                            {/* Navigation Arrows - Floating Design */}
                            <div className="flex justify-end space-x-3 mb-2">
                                <button className="prev-page flex items-center bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    <ChevronLeft size={20} className="text-blue-600" />
                                    <span className="sr-only">Previous venue</span>
                                </button>
                                <button className="next-page flex items-center bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    <ChevronRight size={20} className="text-blue-600" />
                                    <span className="sr-only">Next venue</span>
                                </button>
                            </div>

                            {/* Swiper Container */}
                            <div className="relative">
                                <Swiper
                                    modules={[Navigation, Pagination]}
                                    spaceBetween={24}
                                    loop={false}
                                    speed={500}
                                    slidesPerView={4}
                                    autoplay={{
                                        delay: 50000,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                        el: '.swiper-pagination',
                                        type: 'bullets',
                                    }}
                                    navigation={{
                                        nextEl: '.next-page',
                                        prevEl: '.prev-page',
                                    }}
                                    breakpoints={{
                                        320: {
                                            slidesPerView: 1,
                                            spaceBetween: 16
                                        },
                                        640: {
                                            slidesPerView: 1,
                                            spaceBetween: 16
                                        },
                                        768: {
                                            slidesPerView: 2,
                                            spaceBetween: 20
                                        },
                                        1024: {
                                            slidesPerView: 3,
                                            spaceBetween: 24
                                        },
                                        1280: {
                                            slidesPerView: 4,
                                            spaceBetween: 24
                                        }
                                    }}
                                    className="w-full"
                                >
                                    {uniqueVenue?.sort((a, b) => a.number - b.number)?.map((venue, index) => {
                                        const venueSessions = sessions?.filter?.(item => item?.venue?.id === venue?.id);
                                        return (
                                            <SwiperSlide key={index}>
                                                <div className="h-full rounded-xl overflow-hidden flex flex-col Cards">
                                                    {/* Venue Header */}
                                                    {/* <div className="bg-gray-800 text-black p-4 shadow-md bg-white"> */}
                                                    <div className="bg-gray-800 text-black p-4 mb-2 shadow-md bg-white rounded-lg">
                                                        <div className="flex items-center">
                                                            <div className="flex-shrink-0 flex items-center justify-center  min-w-[1.5rem] h-[1.5rem] px-2 rounded-full bg-[#efc847] text-gray-900 font-bold mr-3">
                                                                {venue?.number}
                                                            </div>

                                                            <div className="flex-grow">
                                                                <h3 className="font-semibold text-lg hover:text-[#efc847] transition-colors duration-200">
                                                                    {venue?.name}
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Sessions List */}
                                                    <div className="flex-grow overflow-y-auto p-1" style={{ maxHeight: 'calc(100vh - 300px)' }}>
                                                        {venueSessions?.length > 0 ? (
                                                            <div className="space-y-4">
                                                                {venueSessions?.map((session, index) => {
                                                                    const dateTime = formatSessionDateTime(session, index);
                                                                    return (
                                                                        <div key={index} className="rounded-lg bg-white px-4 py-4 mb-[30px] shadow-md hover:shadow-xl transition-shadow duration-200">
                                                                            {/* Session Header */}
                                                                            <div className="flex justify-between items-start mb-3">
                                                                                <div className="flex flex-wrap items-center gap-2">
                                                                                    {dateTime && (
                                                                                        <>
                                                                                            <span className="inline-flex items-center py-0.5 rounded-full text-xs font-medium  text-gray-600">
                                                                                                <CalendarDays className="w-4 h-4 mr-1" />  {dateTime.day}
                                                                                            </span>
                                                                                            <span className="inline-flex items-center text-xs text-gray-600">
                                                                                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                                                </svg>
                                                                                                {dateTime.timeRange}
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                                <div className="flex items-center">
                                                                                    {session?.delegative_exclusive === "YES" && (
                                                                                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-[#efc847] text-black">
                                                                                            Delegate Only
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            {/* Session Content */}
                                                                            <div className='border-t border-gray-200 pt-3'>
                                                                                <h3 className="text-lg font-bold text-black">{session?.name}</h3>

                                                                                <span className="inline-block py-1 bg-gray-100 text-gray-800 text-xs font-medium rounded-full mb-3">
                                                                                    {session?.category?.name}
                                                                                </span>

                                                                                {/* People Lists */}
                                                                                <div className="space-y-4">
                                                                                    {/* Speakers */}
                                                                                    {session?.session_speackers?.length > 0 && (
                                                                                        <div>
                                                                                            <h4 className="text-sm font-semibold text-black mb-1">Speakers</h4>
                                                                                            <div className="flex flex-wrap gap-2">
                                                                                                {session?.session_speackers
                                                                                                    ?.slice()
                                                                                                    ?.sort((a, b) => a.id - b.id)
                                                                                                    ?.map((element) => {
                                                                                                        const speaker = allSpeakers?.find(speaker => speaker.id === element.speaker.id);
                                                                                                        if (!speaker) return null;
                                                                                                        return (
                                                                                                            <Link
                                                                                                                key={speaker.id}
                                                                                                                // to={`/speaker-view/${element.speaker.id}`}
                                                                                                                className="inline-flex items-center px-3 py-1 rounded-full text-sm text-black bg-[#f6e8ba] hover:bg-[#f0872a87] transition-colors duration-200"
                                                                                                            >
                                                                                                                <User className="w-4 h-4 mr-1" />  {speaker.heading}
                                                                                                            </Link>
                                                                                                        );
                                                                                                    })}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Moderators */}
                                                                                    {session?.session_moderators?.length > 0 && (
                                                                                        <div>
                                                                                            <h4 className="text-sm font-semibold text-black mb-1">Chair</h4>
                                                                                            <div className="flex flex-wrap gap-2">
                                                                                                {session?.session_moderators?.map((element, idx) => {
                                                                                                    const speaker = allSpeakers?.find(speaker => speaker.id === element.speaker.id);
                                                                                                    if (!speaker) return null;
                                                                                                    return (
                                                                                                        <Link
                                                                                                            key={idx}
                                                                                                            // to={`/speaker-view/${element.speaker.id}`}
                                                                                                            // className="inline-flex items-center py-1 rounded-full text-sm text-black hover:text-[#f0872a87] transition-colors duration-200"
                                                                                                            className="inline-flex items-center px-3 py-1 rounded-full text-sm text-black bg-[#f6e8ba] hover:bg-[#f0872a87] transition-colors duration-200"
                                                                                                        >
                                                                                                            <User className="w-4 h-4 mr-1" /> {speaker?.heading}
                                                                                                        </Link>
                                                                                                    );
                                                                                                })}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Storytellers */}
                                                                                    {session?.speakers?.length > 0 && (
                                                                                        <div>
                                                                                            <h4 className="text-sm font-semibold text-black mb-1">Participants</h4>
                                                                                            <div className="flex flex-wrap gap-2">
                                                                                                {session?.speakers?.map((element, idx) => (
                                                                                                    <Link
                                                                                                        key={idx}
                                                                                                        // to={`/speakerview/${element?.id}/${element?.heading}`}
                                                                                                        className="inline-flex items-center py-1 rounded-full text-sm text-black hover:text-[#f0872a87] transition-colors duration-200"
                                                                                                    >
                                                                                                        <User className="w-4 h-4 mr-1" />  {element?.heading}
                                                                                                    </Link>
                                                                                                ))}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                                <div className="mt-4 pt-3 border-t border-gray-200"></div>

                                                                                {/* Venue Number and Sponser names */}
                                                                                <div className="bg-gray-800 text-black">
                                                                                   {session?.session_sponsors?.length > 0 && (
                                                                                        <div>
                                                                                            <p>
                                                                                                Sponsor:{" "}
                                                                                                <span>
                                                                                                    {session.session_sponsors.map((sponsor, idx) => (
                                                                                                        <span key={idx} className="text-black font-semibold mr-2">
                                                                                                            {sponsor.logo?.name}
                                                                                                        </span>
                                                                                                    ))}
                                                                                                </span>
                                                                                            </p>
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="flex items-inherit justify-end">
                                                                                        <div className="flex-shrink-0 flex items-center justify-center min-w-[1.5rem] h-[1.5rem] px-2 rounded-full bg-[#efc847] text-gray-900 font-semibold mr-3">                                                                                            {venue?.number}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        ) : (
                                                            <div className="text-center py-8 text-gray-500">
                                                                No sessions found for this venue
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>

                                {/* Pagination */}
                                <div className="swiper-pagination mt-4 flex justify-center space-x-2"></div>
                            </div>
                        </div>
                    </div>




                </>
            )}
            <Footer />
        </div>
    );
};

export default SessionList;